import { importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import {TimeoutModule} from 'od-component-library';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { HttpInterceptor } from '_@shared/services/http-interceptor.service';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app/app-routing.module';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, AppRoutingModule, TimeoutModule),
    {provide: HTTP_INTERCEPTORS, useClass: HttpInterceptor, multi: true},
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
  ]
}).catch();
